module.exports = __webpack_public_path__ + "static/media/disable-green.d9f54e2a.svg";